import React, { Component } from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'
import { Tabs, Tab } from 'material-ui/Tabs'
import { SelectField, MenuItem } from 'material-ui'
import Associations from '../associations'
import api from '../../api'

const tasksColumns = [
  { name: 'ID', prop: 'id' },
  { name: 'Task', prop: 'task' },
  { name: 'Position', prop: 'position' },
  { name: 'Day', prop: 'day_id', references: 'admin/days', displayProp: 'date' }
]

const sectionsColumns = [
  { name: 'ID', prop: 'id' },
  { name: 'Title', prop: 'title' },
  { name: 'Position', prop: 'position' },
  { name: 'Required', prop: 'is_required' }
]

class EditHomework extends Component<any, any> {
  constructor (props) {
    super(props)

    // Parse tab from URL query parameter
    const urlParams = new URLSearchParams(window.location.search)
    const tabParam = urlParams.get('tab')
    let initialTab = 0

    if (tabParam === 'sections') {
      initialTab = 1
    } else if (tabParam === 'tasks') {
      initialTab = 2
    }

    this.state = {
      activeTab: initialTab,
      homework: null,
      requiredSectionsMode: 'all'
    }
  }

  componentDidMount () {
    this.loadHomework()
  }

  loadHomework = () => {
    api.get(`admin/homeworks/${this.props.params.homeworkId}`)
      .then(res => res.json())
      .then(homework => {
        this.setState({
          homework,
          requiredSectionsMode: homework.required_sections_mode || 'all'
        })
      })
  }

  handleRequiredSectionsModeChange = (event, index, value) => {
    this.setState({ requiredSectionsMode: value })

    const body = { required_sections_mode: value }
    api.patch(`admin/homeworks/${this.props.params.homeworkId}`, { body })
      .then(res => res.json())
      .then(homework => {
        this.setState({ homework })
      })
  }

  handleTabChange = (value) => {
    this.setState({ activeTab: value })

    // Update URL without page reload
    // @ts-ignore
    const url = new URL(window.location)
    const tabNames = ['homework', 'sections', 'tasks']
    url.searchParams.set('tab', tabNames[value])
    window.history.replaceState({}, '', url)
  }

  updateResults = (task, body, state, setState) => {
    api.patch('admin/homework_tasks/' + task.id, { body })
      .then(res => res.json())
      .then(task => {
        const associatedRecords = Object.assign({}, state.associatedRecords, { [task.id]: task })
        setState({ associatedRecords })
        const body = {
          'filters[homework_id]': task.homework_id
        }
        api.get('admin/homework_tasks', { body })
          .then(res => res.json())
          .then(tasks => {
            tasks = tasks.reduce((a, r) => {
              a[r.id] = r
              return a
            }, {})
            setState({ associatedRecords: tasks })
          })
      })
  }

  updateSectionResults = (section, body, state, setState) => {
    api.patch('admin/homework_sections/' + section.id, { body })
      .then(res => res.json())
      .then(section => {
        const associatedRecords = Object.assign({}, state.associatedRecords, { [section.id]: section })
        setState({ associatedRecords })
        const body = {
          'filters[homework_id]': section.homework_id
        }
        api.get('admin/homework_sections', { body })
          .then(res => res.json())
          .then(sections => {
            sections = sections.reduce((a, r) => {
              a[r.id] = r
              return a
            }, {})
            setState({ associatedRecords: sections })
          })
      })
  }

  getTaskActions = () => [
    {
      label: '🔼',
      handlePress: (task, state, setState) => {
        const body = {
          position: (state.associatedRecords[task.id].position || 1) - 1,
          moveUp: true
        }
        this.updateResults(task, body, state, setState)
      }
    },
    {
      label: '🔽',
      handlePress: (task, state, setState) => {
        const body = {
          position: (state.associatedRecords[task.id].position || 0) + 1
        }
        this.updateResults(task, body, state, setState)
      }
    }
  ]

  getSectionActions = () => [
    {
      label: '🔼',
      handlePress: (section, state, setState) => {
        const body = {
          position: (state.associatedRecords[section.id].position || 1) - 1,
          moveUp: true
        }
        this.updateSectionResults(section, body, state, setState)
      }
    },
    {
      label: '🔽',
      handlePress: (section, state, setState) => {
        const body = {
          position: (state.associatedRecords[section.id].position || 0) + 1
        }
        this.updateSectionResults(section, body, state, setState)
      }
    }
  ]

  getSectionBaseRecord = ({ records, joinRecords }) => {
    // Calculate the next available position based on current sections
    // Use joinRecords (what's displayed) instead of associatedRecords (cached)
    let maxPosition = 0

    if (joinRecords && Array.isArray(joinRecords) && joinRecords.length > 0) {
      // Get positions from joinRecords mapped through associatedRecords
      const positions = joinRecords
        .map(jr => records[jr.id])
        .filter(record => record && record.position)
        .map(record => record.position)
      maxPosition = positions.length > 0 ? Math.max(...positions) : 0
    }

    return {
      homework_id: this.props.params.homeworkId,
      position: maxPosition + 1,
      title: '',
      is_required: false,
      content: ''
    }
  }

  render () {
    const { props } = this
    return (
      <Tabs value={this.state.activeTab} onChange={this.handleTabChange}>
        <Tab value={0} label='Edit Homework'>
          <Edit
// @ts-ignore
            title='Editing Homework'
            fields={fields}
            apiPath={`admin/homeworks/${props.params.homeworkId}`}
            successRedirectPath='/write-now/homework'
            buildMenuItems={menuItems}
          />
        </Tab>
        <Tab value={1} label='Manage Sections'>
          <Associations
// @ts-ignore
            title='Manage Homework Sections'
            fields={require('../homework-sections/fields')(props.params.homeworkId)}
            columns={sectionsColumns}
            baseRecord={this.getSectionBaseRecord}
            joinApiPath='admin/homework_sections'
            associationApiPath='admin/homework_sections'
            joinApiQuery={{ 'filters[homework_id]': props.params.homeworkId }}
            associationIdField='id'
            queryOrder={[{
              column: 'position',
              direction: 'asc'
            }]}
            sortFunction={(idField, associatedRecords) => (a, b) => {
              const aPos = associatedRecords[a[idField]] ? associatedRecords[a[idField]].position : a.position
              const bPos = associatedRecords[b[idField]] ? associatedRecords[b[idField]].position : b.position
              return aPos - bPos
            }}
            customActions={this.getSectionActions()}
            viewAssociation={({ id }) => `/write-now/homework/${props.params.homeworkId}/sections/${id}/edit`}
            tableHeaderSlot={
              <div style={{ maxWidth: 500 }}>
                <SelectField
                  floatingLabelText='Required Sections Completion Mode'
                  value={this.state.requiredSectionsMode}
                  onChange={this.handleRequiredSectionsModeChange}
                  fullWidth
                  hintText='Determines how required sections contribute to homework completion'
                >
                  <MenuItem value='all' primaryText='All required sections must be completed' />
                  <MenuItem value='any' primaryText='Any one required section completes the homework' />
                </SelectField>
              </div>
            }
          />
        </Tab>
        <Tab value={2} label='Manage Tasks'>
          <Associations
// @ts-ignore
            title='Manage Homework Tasks'
            fields={require('../homework-tasks/fields')(props.params.homeworkId)}
            columns={tasksColumns}
            baseRecord={{ homework_id: props.params.homeworkId }}
            joinApiPath='admin/homework_tasks'
            associationApiPath='admin/homework_tasks'
            joinApiQuery={{ 'filters[homework_id]': props.params.homeworkId }}
            associationIdField='id'
            queryOrder={[{
              column: 'position',
              direction: 'asc'
            }]}
            sortFunction={(idField, associatedRecords) => (a, b) => {
              const aPos = associatedRecords[a[idField]] ? associatedRecords[a[idField]].position : a.position
              const bPos = associatedRecords[b[idField]] ? associatedRecords[b[idField]].position : b.position
              return aPos - bPos
            }}
            customActions={this.getTaskActions()}
          />
        </Tab>
      </Tabs>
    )
  }
}

export default EditHomework
